import type { SongSummary } from '@pipi/shared';
import { Music2 } from 'lucide-react';
import { useState } from 'react';

function hash(value: string) {
  return [...value].reduce((total, character) => (total * 31 + character.charCodeAt(0)) >>> 0, 2166136261);
}

export function CoverArt({ song, className = '' }: { song: SongSummary; className?: string }) {
  const [failed, setFailed] = useState(false);
  const hue = hash(song.id) % 360;
  const background = `linear-gradient(145deg, hsl(${hue} 55% 30%), hsl(${(hue + 32) % 360} 70% 13%))`;
  return (
    <div className={`cover-art cover-art--${song.providerKind} ${className}`} style={{ background }}>
      {song.artworkUrl && !failed ? (
        <img src={song.artworkUrl} alt="" loading="lazy" onError={() => setFailed(true)} />
      ) : (
        <div className="cover-art__fallback">
          {song.providerKind === 'demo'
            ? <img className="cover-art__demo-mascot" src="/brand/pipi-karaoke-mascot.png" alt="" />
            : <Music2 aria-hidden size={42} />}
          <span>{song.title.slice(0, 1)}</span>
        </div>
      )}
      <div className="cover-art__wash" />
    </div>
  );
}
